import { Component } from '@angular/core';
import { outlawCommunityConfig } from '@app/core/configs/community.config';

@Component({
  selector: 'app-community-logo',
  template:
    '<a href="/" class="logo" [className]="\'community-logo-\' + communityName" [title]="communityTitle + \' Community\'"></a>',
  styles: [':host { display: block; width: 100%; }'],
})
export class CommunityLogoComponent {
  protected readonly communityName = outlawCommunityConfig.name;
  protected readonly communityTitle = outlawCommunityConfig.title;
}
